<template>

  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="业绩周期">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.reg_date" type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label=""><el-input v-model="formInline.user_id" placeholder="请输入用户ID"></el-input></el-form-item>
        <el-form-item><el-button icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
        <el-form-item><el-button size="small" type="success" @click="onExport">导出</el-button></el-form-item>
      </el-form>
    </div>
    
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" >
          <el-table-column prop="user_id" label="用户ID" width="80" sortable="custom"></el-table-column>
          <!-- <el-table-column prop="nickName" label="昵称"></el-table-column> -->
          <el-table-column prop="nickName" label="用户" width="300">
            <template slot-scope="scope">
              <div class="d-s-c">
                <img :src="scope.row.avatarUrl" width="60px" height="60px" />
                <div class="ml10">
                  <p class="f14 fb">{{ scope.row.nickName }} <el-tag type="info" class="style1-tag">{{ scope.row.grade.name }}</el-tag></p>
                  <p class="gray3" v-if="scope.row.mobile">手机：{{ scope.row.mobile }}</p>
                  <p class="gray9">性别：{{ scope.row.gender |  }}</p>
                  <p class="gray9" v-if="scope.row.referee_id">推荐人ID：{{ scope.row.referee_id }} {{scope.row.referee}}</p>
                  <p class="gray9" v-if="scope.row.referee_id && scope.row.user_referee!=null">
                    推荐人：{{ scope.row.user_referee.nickName }} [<span class="golden">{{ grade[scope.row.user_referee.grade_id].name }}</span>] 
                    
                  </p>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="points" label="积分" sortable="custom" align="center"></el-table-column>
          <el-table-column prop="balance" label="余额" sortable="custom" align="center"></el-table-column>
          <el-table-column  label="下级团队长总业绩" sortable="custom" align="center">
            <template slot-scope="scope">
              {{scope.row.total_amount}}
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="注册时间" width="140" sortable="custom"></el-table-column>
         
        </el-table>
        </div>
      </el-form>
      <!--分页--> 
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import MultigroupApi from '@/api/multigroup.js';
import qs from 'qs';
export default {
  components: {},
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      formInline: {},
      status: ['未启用', '启用']
    };
  },
  created() {
    console.log(88888)
    /*获取列表*/
    this.getTableList();
  },
  methods: {

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },
 /*跳转页面*/
    gotoPage(path, query) {
      this.$router.push({
        path: path,
        query: query
      });
    },
    onExport: function() {
      // console.log(this.formInline);return;
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/plus.multigroup.agent/export?' + qs.stringify(this.formInline);
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      MultigroupApi.getAgent(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/multigroup/agent/index.vue